import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { authGuard, authGuardPermission } from "../auth";

Vue.use(VueRouter);

const SITE_TITLE = 'DomainEngine';

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: `${SITE_TITLE} - Home`,
      },
      component: Home
    },
    {
      path: '/profile',
      name: 'Profile',
      meta: {
        title: `${SITE_TITLE} - Profile`,
      },
      component: () => import(/* webpackChunkName: "Profile" */ '../views/Profile.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/applications',
      component: () => import(/* webpackChunkName: "ApplicationRoot" */ '../views/Application.vue'),
      beforeEnter: authGuard,
      children: [
        {
          path: 'create',
          name: 'ApplicationsCreate',
          component: () => import(/* webpackChunkName: "ApplicationCreate" */ '../views/ApplicationCreate.vue'),
          meta: {
            title: `${SITE_TITLE} - Create Application`,
            requiresPermission: {
              namespace: 'api.domainengine',
              permission: 'create:application'
            }
          },
          beforeEnter: authGuardPermission
        },
        {
          path: '',
          name: 'ApplicationsIndex',
          component: () => import(/* webpackChunkName: "ApplicationIndex" */ '../views/ApplicationIndex.vue'),
          meta: {
            title: `${SITE_TITLE} - Applications`,
            requiresPermission: {
              namespace: 'api.domainengine',
              permission: 'get:application'
            }
          },
          beforeEnter: authGuardPermission
        }
      ]
    }
  ]
});

//https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  next();
});

export default router;